import React from 'react'

import logo from '../../../assets/logo.png'
import arrow from '../../../assets/arrow.svg'

import styles from './styles'

const StandardNavigation = props => (
  <nav className={styles.standardNavigation}>
    <div className={styles.navigationBarItems}>
      <a href="/" className={styles.offerzenLogoLink}>
        <img src={logo} alt="offerzen-logo" className={styles.offerzenLogoImage} />
      </a>

      <If condition={props.showNavLinks}>
        <div>
          <div className={styles.navigationLinksContainer}>
            <p className={styles.navigationText}>Are you an employer?</p>
            <a className={styles.outlinedNavButton} href="/employers/signup">
              Hire developers
            </a>
          </div>

          <div className={styles.mobileNav}>
            <a className={styles.loginButton} href="/users/sign_in">
              Log in <img className={styles.arrowImage} src={arrow} alt="arrow right" />
            </a>
          </div>
        </div>
      </If>
    </div>
  </nav>
)

export default StandardNavigation
